module.exports = __webpack_public_path__ + "travel.c7e1555b6c74733ae24c.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/travel/webfont/travel.svg
// module id = ../../../../../src/assets/fonts/line-icons-pro/travel/webfont/travel.svg
// module chunks = styles